export default __webpack_public_path__ + "static/NavalAviatorBadge-e329b7dc35a5c3fad778dea855b01c92.jpg";